/*
  Caviére serving calculator (Feature 8)
  Uses the guests per size from Theme settings (or the size name, for example
  "125g (FOR 4-6)") and finds the lowest priced way to serve the guest count with one tin or
  two (always rounding up). Then it selects that size and quantity for the
  shopper. For two different sizes it offers a one-tap Add for the second tin.
  Plain JavaScript, no libraries. About 3 KB.
*/
(function () {
  if (window.__caviereServing) return;
  window.__caviereServing = true;

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // Guests per size. Read from Theme settings (data-guest-map) when set,
  // otherwise from the size name itself, for example "125g (FOR 4-6)".
  var DEFAULT_MAP = '30g = 1-2, 50g = 2-3, 125g = 4-6, 250g = 10-12, 500g = 20-25';

  function readMap(text) {
    var map = {};
    (text || '').split(/[,\n]+/).forEach(function (pair) {
      var m = pair.match(/^\s*([^=:]+?)\s*[=:]\s*(\d+)\s*(?:-|to|–)?\s*(\d+)?\s*$/i);
      if (m) map[m[1].trim().toLowerCase()] = { min: Number(m[2]), max: Number(m[3] || m[2]) };
    });
    return map;
  }

  function parse(variant, map) {
    var text = variant.title || variant.option || '';
    var size = text.split('(')[0].trim();
    var range = text.match(/for\s*(\d+)\s*(?:-|to|–)\s*(\d+)/i) || text.match(/for\s*(\d+)/i);
    var guests = range ? { min: Number(range[1]), max: Number(range[2] || range[1]) } : map && map[size.toLowerCase()];
    if (!guests) return null;
    return {
      id: variant.id,
      option: variant.option,
      price: variant.price,
      size: size,
      min: guests.min,
      max: guests.max
    };
  }

  // 1. If a size's own label covers the party (4 guests -> "125g (FOR 4-6)"), use it.
  // 2. Otherwise the lowest priced single tin, or pair of tins, that covers everyone.
  function plan(sizes, guests) {
    for (var s = 0; s < sizes.length; s++) {
      if (guests >= sizes[s].min && guests <= sizes[s].max) {
        return { tins: [sizes[s]], price: sizes[s].price, total: sizes[s].max };
      }
    }
    var best = null;
    function consider(option) {
      if (
        !best ||
        option.price < best.price ||
        (option.price === best.price && option.tins.length < best.tins.length)
      ) {
        best = option;
      }
    }
    sizes.forEach(function (a, i) {
      if (a.max >= guests) consider({ tins: [a], price: a.price, total: a.max });
      sizes.slice(i).forEach(function (b) {
        var total = a.max + b.max;
        if (total >= guests && !(a.max >= guests || b.max >= guests)) {
          var big = a.max >= b.max ? a : b;
          var small = big === a ? b : a;
          consider({ tins: [big, small], price: a.price + b.price, total: total });
        }
      });
    });
    return best;
  }

  function fill(template, values) {
    return template.replace(/\[(\w+)\]/g, function (match, key) {
      return values[key] != null ? values[key] : match;
    });
  }

  function selectVariant(scope, sizeOption) {
    var picker = scope.querySelector('variant-selects, variant-radios');
    if (!picker) return false;
    var radios = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === sizeOption) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    var selects = picker.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var opts = selects[j].options;
      for (var k = 0; k < opts.length; k++) {
        if (opts[k].value === sizeOption || opts[k].textContent.trim() === sizeOption) {
          if (selects[j].value !== opts[k].value) {
            selects[j].value = opts[k].value;
            selects[j].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }
    }
    return false;
  }

  function setQuantity(scope, qty) {
    // Dawn may redraw the quantity box after a size change, so set it after a short pause.
    setTimeout(function () {
      var input = scope.querySelector('quantity-input input[name="quantity"], input[name="quantity"]');
      if (!input || String(input.value) === String(qty)) return;
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 450);
  }

  function setup(box) {
    if (box.getAttribute('data-ready') === 'true') return;
    box.setAttribute('data-ready', 'true');

    var map = readMap(box.getAttribute('data-guest-map') || DEFAULT_MAP);
    var data = [];
    try {
      data = JSON.parse(box.querySelector('[data-cav-variants]').textContent);
    } catch (e) {
      return;
    }
    var sizes = data
      .filter(function (v) {
        return v.available;
      })
      .map(function (v) {
        return parse(v, map);
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.max - b.max;
      });
    if (sizes.length < 2) {
      box.hidden = true;
      return;
    }

    var scope = box.closest('product-info') || box.closest('.product') || document;
    var input = box.querySelector('.cav-serve__input');
    var msg = box.querySelector('.cav-serve__msg');
    var extra = box.querySelector('.cav-serve__extra');
    var extraLabel = extra.querySelector('.cav-addon__btn-label');
    var link = box.querySelector('.cav-serve__link');
    var maxGuests = Number(box.getAttribute('data-max-guests')) || 50;
    var timer;

    function setMessage(html) {
      // Only our own escaped template text and sizes go in here.
      msg.innerHTML = html;
    }

    function esc(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function update(guests, apply) {
      extra.hidden = true;
      link.hidden = true;
      if (!guests || guests < 1) {
        setMessage('');
        return;
      }
      if (guests > maxGuests) {
        setMessage(esc(fill(box.getAttribute('data-msg-big'), { max: maxGuests })));
        link.href = box.getAttribute('data-big-link') || '/pages/contact';
        link.textContent = box.getAttribute('data-big-label') || 'Contact us';
        link.hidden = false;
        return;
      }
      var best = plan(sizes, guests);
      if (!best) return;
      var main = best.tins[0];
      var strong = function (text) {
        return '<strong>' + esc(text) + '</strong>';
      };

      if (best.tins.length === 1) {
        setMessage(
          fill(esc(box.getAttribute('data-msg-one')), {
            size: strong(main.size),
            range: main.min === main.max ? String(main.max) : main.min + ' to ' + main.max
          })
        );
        if (apply) {
          selectVariant(scope, main.option);
          setQuantity(scope, 1);
        }
        return;
      }

      var second = best.tins[1];
      if (second.id === main.id) {
        setMessage(fill(esc(box.getAttribute('data-msg-same')), { size: strong(main.size), total: best.total }));
        if (apply) {
          selectVariant(scope, main.option);
          setQuantity(scope, 2);
        }
        return;
      }

      setMessage(
        fill(esc(box.getAttribute('data-msg-mix')), {
          size: strong(main.size),
          extra: strong(second.size),
          total: best.total
        })
      );
      extra.setAttribute('data-variant-id', second.id);
      extra.setAttribute('data-added-text', second.size + ' added to your cart');
      extra.setAttribute('aria-label', 'Add a ' + second.size + ' to your cart, ' + money(second.price));
      extraLabel.textContent = fill(box.getAttribute('data-add-label') || 'Add the [extra] too', { extra: second.size }) + ' · ' + money(second.price);
      extra.removeAttribute('aria-busy');
      extra.disabled = false;
      extra.hidden = false;
      if (apply) {
        selectVariant(scope, main.option);
        setQuantity(scope, 1);
      }
    }

    function fromInput(apply) {
      var value = parseInt(input.value, 10);
      if (isNaN(value)) value = 0;
      if (value > maxGuests + 1) value = maxGuests + 1;
      if (value < 0) value = 0;
      update(value, apply);
    }

    box.addEventListener('click', function (event) {
      var step = event.target.closest('[data-step]');
      if (!step) return;
      var value = parseInt(input.value, 10) || 0;
      value = Math.max(1, Math.min(maxGuests + 1, value + Number(step.getAttribute('data-step'))));
      input.value = value;
      fromInput(true);
    });

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fromInput(true);
      }, 350);
    });
  }

  window.CaviereServing = { plan: plan, parse: parse, readMap: readMap };

  function init() {
    document.querySelectorAll('[data-cav-serving]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();